import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=7084656e&scoped=true&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"
import style0 from "./edit.vue?vue&type=style&index=0&id=7084656e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7084656e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/.jenkins/workspace/crm-ui/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7084656e')) {
      api.createRecord('7084656e', component.options)
    } else {
      api.reload('7084656e', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=7084656e&scoped=true&", function () {
      api.rerender('7084656e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/crm/deliver/deliveryNote/edit.vue"
export default component.exports